export default {"src":"/_next/static/media/board_blitz.ca399bd5.svg","height":606,"width":707,"blurWidth":0,"blurHeight":0};